import React, { useState } from 'react';
import { RaceMeeting, Runner } from '../types';
import { formatTime, formatDate } from '../utils/helpers';
import RaceCard from './RaceCard';
import './RaceMeetingCard.css';

interface RaceMeetingCardProps {
  meeting: RaceMeeting;
  runners: Runner[];
  allCollapsed?: boolean;
}

const RaceMeetingCard: React.FC<RaceMeetingCardProps> = ({ 
  meeting, 
  runners,
  allCollapsed = false
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const getMeetingTypeColor = (type: string): string => {
    switch (type.toLowerCase()) {
      case 'flat':
        return '#3b82f6'; // blue
      case 'jump':
        return '#10b981'; // green
      case 'mixed':
        return '#f59e0b'; // amber
      default:
        return '#6b7280'; // gray
    }
  };


  return (
    <div className="race-meeting-card">
      <div 
        className="meeting-header"
        onClick={toggleExpanded}
      >
        {/* Desktop version - hidden on mobile */}
        <div className="desktop-meeting-content">
          <div className="meeting-title">
            <h3 className="course-name">{meeting.course}</h3>
            <span 
              className="meeting-type"
              style={{ color: getMeetingTypeColor(meeting.meeting_type) }}
            >
              {meeting.meeting_type}
            </span>
          </div>
          
          <div className="meeting-details-row">
            <div className="detail-item">
              <span className="detail-label">Date:</span>
              <span className="detail-value">{formatDate(meeting.meeting_date)}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Going:</span>
              <span className="detail-value">{meeting.going}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Surface:</span>
              <span className="detail-value">{meeting.surface}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">First:</span>
              <span className="detail-value">{formatTime(meeting.first_race_time)}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Last:</span>
              <span className="detail-value">{formatTime(meeting.last_race_time)}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Qualifying Races:</span>
              <span className="detail-value">{meeting.total_races}</span>
            </div>
          </div>
        </div>

        {/* Mobile version - hidden on desktop */}
        <div className="mobile-meeting-content">
          <h3 className="course-name">{meeting.course}</h3>
          <span 
            className="meeting-type-badge"
            style={{ 
              backgroundColor: getMeetingTypeColor(meeting.meeting_type),
              color: 'white'
            }}
          >
            {meeting.meeting_type.toUpperCase()}
          </span>
          <div className="expand-indicator">
            <span className={`expand-icon ${isExpanded ? 'expanded' : ''}`}>
              ›
            </span>
          </div>
        </div>
        
        {/* Desktop expand indicator */}
        <div className="desktop-expand-indicator">
          <span className={`expand-icon ${isExpanded ? 'expanded' : ''}`}>
            ›
          </span>
        </div>
      </div>

      {isExpanded && (
        <div className="meeting-races">
          <div className="races-grid">
            {meeting.races
              .sort((a, b) => a.race_time.localeCompare(b.race_time))
              .map((race) => (
                <RaceCard
                  key={race.race_id}
                  race={race}
                  runners={runners}
                  allCollapsed={allCollapsed}
                />
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RaceMeetingCard;
